import axios from 'axios';
import { API, authHeaders } from './client';

export const getDocuments = () =>
  axios.get(`${API}/documents`).then(r => r.data);

export const createDocument = (token, data) =>
  axios.post(`${API}/documents`, data, authHeaders(token)).then(r => r.data);

export const updateDocument = (token, id, data) =>
  axios.put(`${API}/documents/${id}`, data, authHeaders(token)).then(r => r.data);

export const deleteDocument = (token, id) =>
  axios.delete(`${API}/documents/${id}`, authHeaders(token)).then(r => r.data);
